"use client";

import Image from "next/image";
import { cn } from "@/lib/utils/general";

interface ProfileImageProps {
	src: string | null;
	alt: string;
	size?: "sm" | "md" | "lg";
	className?: string;
}

export default function ProfileImage({
	src,
	alt,
	size = "md",
	className,
}: ProfileImageProps) {
	const sizeClasses = {
		sm: "w-8 h-8",
		md: "w-10 h-10",
		lg: "w-24 h-24",
	};

	const fallbackInitial = alt.charAt(0).toUpperCase();

	return (
		<div
			className={cn(
				"relative overflow-hidden rounded-full bg-primary",
				sizeClasses[size],
				className
			)}
		>
			{src && src !== "" ? (
				<Image
					src={src}
					alt={alt}
					fill
					sizes={`${size === "lg" ? "96px" : size === "md" ? "40px" : "32px"}`}
					className="object-cover"
				/>
			) : (
				<div
					className={`flex items-center justify-center w-full h-full text-white font-bold ${
						size === "lg"
							? "text-3xl"
							: size === "md"
							? "text-base"
							: "text-base"
					}`}
				>
					{fallbackInitial}
				</div>
			)}
		</div>
	);
}
